import React from 'react';
import PropTypes from 'prop-types';

import { Container, IDesc } from './common/styles';
import OptionsControl from './options-control';
import { updateNotifyOnLike } from '../../../services/profiles/notification-settings-service';

export default function LikeOptionsControl(props) {
  return (
    <Container>
      <IDesc>
        When someone likes my wire
      </IDesc>
      <OptionsControl
        id="like-options"
        options={props.options}
        updateOptionsFunction={updateNotifyOnLike}
      />
    </Container>
  );
}

LikeOptionsControl.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
};
